import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { IState } from 'types/Member';
import { getMemberDetailsThunk } from './memberThunk';

const initialState: IState = {
	errorCode: 0,
	errorMessage: '',
	member: null,
	pending: false,
};

export const getMemberDetails = createAsyncThunk(
	'member/getMemberDetails',
	getMemberDetailsThunk,
);

const memberSlice = createSlice({
	name: 'member',
	initialState,
	reducers: {
		resetMember: () => initialState,
	},
	extraReducers: builder => {
		builder
			.addCase(getMemberDetails.pending, state => {
				state.pending = true;
			})
			.addCase(getMemberDetails.fulfilled, (state, { payload }) => {
				state.member = payload;
				state.pending = false;
			})
			.addCase(getMemberDetails.rejected, state => {
				state.member = null;
				state.pending = false;
			});
	},
});

export const { resetMember } = memberSlice.actions;

export default memberSlice.reducer;
